import { ListDownload } from 'ui/components';

export const ListDownloadFeature: React.FC<Umbraco.ListDownload> = ({ content }) => <ListDownload {...content?.properties} />;
